import React from "react";
import { useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { MdNotificationsNone } from "react-icons/md";

import CprStatusItem from "./cpr/CprStatusItem";
import Flash from "../layout/Flash";
import BottomNavigation from "../layout/BottomNavigation";
import CardComponent from "../layout/CardComponent";
import * as CONST from "../Constants";
import * as API from "../api";

const propTypes = {
  cpr: PropTypes.object.isRequired,
  notifications: PropTypes.array.isRequired,
};
CprNotificationsPage.prototype = propTypes;

export default function CprNotificationsPage(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [flash, showFlash] = React.useState(null);
  const [tracking, setTracking] = React.useState(null);

  const history = useHistory();
  const { id } = useParams();

  React.useEffect(() => {
    const index = props.notifications.findIndex((item) => (item.id == id ? item : null));
    API.markCprAsRead(id);

    // CPR is in notifications
    if (index > -1) {
      setActiveStep(index);
      props.dispatch({
        type: "set_current_by_index",
        payload: props.notifications[index],
      });

    // CPR is NOT in notifications, happens when this component reloads (after some form submit) and we refetch /cprs?needs_attention=true
    // form submitted, CPR no longer in needs_attention = true, OR user enters a URL with CPR ID NOT within notifications (needs_attention = true)
    } else {
      if (props.notifications.length > 0) {
        props.dispatch({
          type: "set_current_by_index",
          payload: props.notifications[0],
        });
        history.push(`/patient_portal/notifications/${props.notifications[0].id}`);
      } else {
        if (props.additional_messages && props.additional_messages.length > 0) {
          history.push(`/patient_portal/additional_messages/${ props.additional_messages[0].id}`);
        }
      }
    }
  }, [props.notifications, props.cpr, id]);

  const Notifications = () => {
    function handleNext() {
      const currentStep = activeStep + 1;
      setActiveStep(currentStep);
      props.dispatch({ type: "set_current_by_index", payload: props.notifications[currentStep] });
      history.push(`/patient_portal/notifications/${props.notifications[currentStep].id}`);
      flash && showFlash(null);
    }

    function handleBack() {
      const currentStep = activeStep - 1;
      setActiveStep(currentStep);
      props.dispatch({ type: "set_current_by_index", payload: props.notifications[currentStep] });
      history.push(`/patient_portal/notifications/${props.notifications[currentStep].id}`);
      flash && showFlash(null);
    }

    return (
      <>
        {flash && id == flash.id && (
          <Flash
            flash={flash}
            handleClose={() => {
              if (props.cpr.cpr_type_response_status || props.cpr.in_review) {
                props.dispatch({
                  type: "set_notification_updated",
                  payload: props.cpr.id,
                });
                props.dispatch({
                  type: "set_current_in_progress_cprs",
                  payload: props.cpr,
                });
              }
              showFlash(null);
            }}
            showButton={props.cpr.cpr_type_response_status || props.cpr.in_review ? true : false}
          />
        )}
        <Box className="carousel-inner">
          <CprStatusItem {...props} flash={(m) => showFlash({ ...m, id: props.cpr.id })} />
        </Box>
        <BottomNavigation
          activeStep={activeStep}
          disableNext={props.notifications.length - 1}
          steps={props.notifications.length}
          variant="dots"
          handleStep={(step) => {
            step > activeStep ? handleNext() : handleBack();
          }}
        />
      </>
    );
  };

  return (
    <Box className="carousel b">
      {props.notifications && !!props.notifications.length > 0 && props.cpr ? (
        <Notifications />
      ) : (
        <CardComponent
          media={<MdNotificationsNone style={{ fontSize: " 6em" }} />}
          message={CONST.NO_NOTIFICATIONS}
        />
      )}
    </Box>
  );
}
